var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransferIconYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4063 9.37502C15.9068 9.37502 16.3125 9.79473 16.3125 10.3125C16.3125 10.7933 15.9627 11.1896 15.512 11.2437L15.4063 11.25H3.09413L5.17208 13.3996C5.52599 13.7657 5.52599 14.3593 5.17208 14.7254C4.84538 15.0634 4.33133 15.0894 3.97581 14.8034L3.89044 14.7254L0.420138 11.1355C-0.182738 10.5118 0.203056 9.46314 1.02063 9.38025L1.12504 9.37502H15.4063ZM11.1405 0.274585C11.4671 -0.0633658 11.9812 -0.0893619 12.3367 0.196596L12.4221 0.274585L15.8924 3.86455C16.4953 4.48822 16.1095 5.53688 15.2919 5.61978L15.1875 5.62501H0.906251C0.405747 5.62501 0 5.20527 0 4.68751C0 4.20673 0.349853 3.81047 0.800564 3.75631L0.906251 3.75001H13.2184L11.1405 1.60042C10.7866 1.2343 10.7866 0.640707 11.1405 0.274585Z",
    fill: "#FEF35A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIconYellow);
export default __webpack_public_path__ + "static/media/transfer-icon-yellow.3bddd9679ddce5623d9f89551bdfd451.svg";
export { ForwardRef as ReactComponent };